<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Cargo Packaging Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.pack }}</td>
            <td class="text-xs-left">{{ props.item.packDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['cargoRatingReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Packaging
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="packDialog" width="800px" lazy v-if="checkAccess(['cargoRatingReview'])" persistent >
        <packaging-dialog :packForm="packForm" @close="doClose" :newPack="newPack"></packaging-dialog>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
          Are you sure that you want to delete the selected Cargo Packaging? ({{deleteCrgoPack}})
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import PackagingDialog from './PackagingDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Cargo Packaging', align: 'left', value: 'pack' },
        { text: 'Cargo Packaging Description', align: 'left', value: 'packDesc' }
      ],
      packForm: {
        pack: undefined,
        packDesc: undefined
      },
      packDialog: undefined,
      newPack: undefined,
      loading: false,
      promptRemove: false,
      selectedCrgoPack: undefined,
      deleteCrgoPack: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.cargo.menu.getCrgoPacks
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((CrgoPack) => {
              const convertCrgoPack = {
                pack: CrgoPack.pack,
                packDesc: CrgoPack.packDesc
              }
              this.items.push(convertCrgoPack)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doReview(Pack) {
      const apiURI = this.$store.state.cargo.menu.getCrgoPack
      const expand = {
        pack: Pack.item.pack
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.packForm.pack = data.pack.pack
          this.packForm.packDesc = data.pack.packDesc
        }
        this.packDialog = true
      }
    },
    doClose() {
      this.packDialog = false
      this.newPack = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.packDialog = true
      this.newPack = true
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedCrgoPack = data
        this.deleteCrgoPack = data.pack + ' - ' + data.packDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.cargo.menu.deletePack
      if (apiURI) {
        this.loading = true
        const expand = {
          pack: this.selectedCrgoPack.pack
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData()
  },
  created() {
    if (this.checkAccess(['cargoRatingReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    PackagingDialog: PackagingDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
